/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/

(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant.id);
      
      // const element = document.querySelector('.delivery-info');
      // const elements = element.children;

      // let submit = document.getElementById("submit");
      // let checkTypewriter = document.querySelector('#parameters');

      // if(checkTypewriter.value == '') {
      //   submit.setAttribute("disabled", "");
      // } else {
      //   submit.removeAttribute("disabled", "");
      // }
      
      // bcpo_product.variants.forEach(variantbcpo => {
      //   if(variantbcpo.id === variant.id) {
      //     if(variantbcpo.inventory_quantity < 1){
      //       setTimeout(() => {
      //         while (elements.length > 0) {
      //           element.removeChild(elements[0]);
      //         }
      //         element.insertAdjacentHTML("beforeend", "<p><strong>Tailoring Time:</strong> 7-14 days</p>")  
      //         element.insertAdjacentHTML("beforeend", "<p><strong>Shipping Time:</strong> 7-14 days</p>")
      //         element.insertAdjacentHTML("beforeend", "<p>This product is Made-To-Order. Whether you choose a standard size or custom measurements, our tailors craft each product to order.</p>")    
      //         element.insertAdjacentHTML("beforeend", "<p>Order today, get it: <strong style='color:rgb(230, 0, 0)'>"+ getDeliveryDate(15, 22) +"</p>")  
      //       }, 500); 
      //     }
      //     else{

      //       setTimeout(() => {
      //         while (elements.length > 0) {
      //           element.removeChild(elements[0]);
      //         }
      //         element.insertAdjacentHTML("beforeend", "<p><strong>Shipping Time:</strong> 5-8 days</p>")  
      //         element.insertAdjacentHTML("beforeend", "<p>Order today, get it: <strong style='color:rgb(230, 0, 0)'>"+ getDeliveryDate(6, 8) +"</p>")
      //       }, 500); 

            
      //     }
      //   }
      // });
      // ... update some element on the page
    }
  });
/*
  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));
*/

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  const selectVariantByClickingImage = {
  // Create variant images from productJson object
  _createVariantImage: function (product) {
    const variantImageObject = {};
    product.variants.forEach((variant) => {
      if (
        typeof variant.featured_image !== 'undefined' &&
        variant.featured_image !== null
      ) {
        const variantImage = variant.featured_image.src
          .split('?')[0]
          .replace(/http(s)?:/, '');
        variantImageObject[variantImage] =
          variantImageObject[variantImage] || {};
        product.options.forEach((option, index) => {
          const optionValue = variant.options[index];
          const optionKey = `option-${index}`;
          if (
            typeof variantImageObject[variantImage][optionKey] === 'undefined'
          ) {
            variantImageObject[variantImage][optionKey] = optionValue;
          } else {
            const oldValue = variantImageObject[variantImage][optionKey];
            if (oldValue !== null && oldValue !== optionValue) {
              variantImageObject[variantImage][optionKey] = null;
            }
          }
        });
      }
    });
    return variantImageObject;
  },
  _updateVariant: function (event, id, product, variantImages) {
    const arrImage = event.target.src
      .split('?')[0]
      .replace(/http(s)?:/, '')
      .split('.');
    const strExtention = arrImage.pop();
    const strRemaining = arrImage.pop().replace(/_[a-zA-Z0-9@]+$/, '');
    const strNewImage = `${arrImage.join('.')}.${strRemaining}.${strExtention}`;
    if (typeof variantImages[strNewImage] !== 'undefined') {
      product.variants.forEach((option, index) => {
        const optionValue = variantImages[strNewImage][`option-${index}`];
        if (optionValue !== null && optionValue !== undefined) {
          const selects = document.querySelectorAll('#'+ id + ' [class*=single-option-selector]');
          const options = selects[index].options;
          for (let option, n = 0; (option = options[n]); n += 1) {
            if (option.value === optionValue) {
              selects[index].selectedIndex = n;
              selects[index].dispatchEvent(new Event('change'));
              break;
            }
          }
        }
      });
    }
  },
  _selectVariant: function() {
    const productJson = document.querySelectorAll('[id^=ProductJson-');
    if (productJson.length > 0) {
      productJson.forEach((product) => {
        const sectionId = product.id.replace("ProductJson-", "shopify-section-");
        const thumbnails = document.querySelectorAll('#'+ sectionId + ' img[src*="/files/"]');
        if (thumbnails.length > 1) {
          const productObject = JSON.parse(product.innerHTML);
          const variantImages = this._createVariantImage(productObject);
          // need to check variants > 1
          if (productObject.variants.length > 1) {
            thumbnails.forEach((thumbnail) => {
              thumbnail.addEventListener('click', (e) =>
                this._updateVariant(e, sectionId, productObject, variantImages),
              );
            });
          }
        }
      });
    }
  },
};
if (document.readyState !== 'loading') {
  selectVariantByClickingImage._selectVariant();
} else {
  document.addEventListener(
    'DOMContentLoaded',
    selectVariantByClickingImage._selectVariant(),
  );
}

  let checkTypewriter = document.querySelector('#parameters');
if (checkTypewriter) {
  let submit = document.getElementById("submit");
  submit.setAttribute("disabled", "");
}

    $.ajax({
    url: 'https://irisdress.store/cdn/shop/files/1-47_1100x.jpg?v=1698159143',
    type: 'HEAD',
    error: function() {
        // File isn't found
    },
    success: function() {
        // File is found! Do the watermarkage.
    }
});
})();

/* custom style for sale popup */
// setTimeout(function(){
//   $("#app-embed-container-75325").addClass("block");
//   document.querySelector('form-embed.block').shadowRoot.querySelector('button._teaserContainer_ou4pe_5').setAttribute('style', 'background-color: #d2815f; box-shadow: none; border-radius: 2px');
//   document.querySelector('form-embed.block').shadowRoot.querySelector('h3').setAttribute('style', 'color: #fff;');
//   document.querySelector('form-embed.block').shadowRoot.querySelector('svg').setAttribute('style', 'fill: #fff;');
// }, 5000);

// setTimeout(function(){
//     $(".r--grid .r--grid-item .r--author").appendTo($(".r--grid .r--grid-item .r--author").parent().siblings().find(".r--item-body"));
// }, 5000);

$(".customize-button").hover(function() {
  $(".customize-info").toggleClass("show");
});


/* custom color input */

setTimeout(function(){
  
    let customColorInput = $(".gpo-input.gpo-text");
    customColorInput.attr("disabled", true);
    var el = $(".gpo-input.gpo-text").find('div');

$("label[for*='variants-Color']").on("click", function() {
      customColorInput.attr("disabled", true);
      el.hide();
});
  
$("label[for*='variants-Color-Custom']").on("click", function() {
    customColorInput.attr("disabled", false);
}); 

$("label[for*='variants-Color-CUSTOM']").on("click", function() {
    customColorInput.attr("disabled", false);
}); 
}, 2000);

$('.home-review-carousel').flickity({
  cellAlign: 'left',
  contain: true,
  lazyLoad: 2,
  freeScroll: true,
  wrapAround: true,
  adaptiveHeight: true
});

$('.product-review-carousel').flickity({
  cellAlign: 'center',
  contain: true,
  freeScroll: true,
  wrapAround: true,
});